import axios from "@/lib/axios";
import { LostNonWarrantyRequestParams } from "../types";

const createLostNonWarrantyRequest = (data: LostNonWarrantyRequestParams) => {
  return axios.post("/customer/flat_rates/lost_non_warranty_request", data);
}

export default createLostNonWarrantyRequest;